import { Box } from '@wix/design-system';
import {
  useProductHat,
  useSelectButton,
  useEffectiveRecommendation,
  useAiRecommendationEnabled,
} from '@wix/package-picker-shared-eclipse';
import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { EclipsePrice } from '../EclipsePrice/EclipsePrice';
import s from './FeaturesGrid.scss';

interface FeaturesGridProductHeaderProps {
  productId: string;
}

export const FeaturesGridProductHeader = ({
  productId,
}: FeaturesGridProductHeaderProps) => {
  const { renderProductHat } = useProductHat({ productId });
  const { data: product, isLoading } =
    EclipsePackagePickerModule.SDK.eclipseOfferingApiClient.hooks.useFetchProduct(
      {
        productId,
      },
    );

  const { SelectButton } = useSelectButton({ productId });

  const { isEnterprise, name } = product ?? {};
  const { isEnabled: isAiRecommendationEnabled } = useAiRecommendationEnabled();
  const { isRecommended } = useEffectiveRecommendation(
    productId,
    product?.isRecommended ?? false,
  );

  if (isLoading) {
    return null;
  }

  const backgroundGradient = isRecommended
    ? 'linear-gradient(180deg, #FFF 0%, #FAF9FF 100%)'
    : 'white';

  return (
    <PlatformFeaturesGrid.Header.Cell
      gap="SP1"
      background={backgroundGradient}
      border="none"
      marginTop="-28px"
      className={isAiRecommendationEnabled ? s.headerCellReveal : undefined}
    >
      <Box padding="0 SP1" boxSizing="border-box">
        {renderProductHat({ height: '26px' })}
      </Box>
      <Box align="center" marginTop="SP2">
        <PlatformFeaturesGrid.Header.Title
          title={name ?? ''}
          size="small"
          className={s.gridPlanTitle}
          dataHook={`grid-plan-title-${productId}`}
        />
      </Box>
      <Box visibility={isEnterprise ? 'hidden' : 'visible'} align="center">
        <EclipsePrice productId={productId} />
      </Box>
      <Box align="center" width="100%" marginBottom="SP3" marginTop="SP1">
        <Box align="center" width="126px" marginBottom="SP3" marginTop="SP1">
          <SelectButton
            variant={isRecommended ? 'primary' : 'secondary'}
            size="medium"
            fullWidth
          />
        </Box>
      </Box>
    </PlatformFeaturesGrid.Header.Cell>
  );
};
